import React from 'react';
import { connect } from 'react-redux';

import IncidentStatusEnum from 'redpoints-model-js/enumeration/IncidentStatusEnum';

import { MoreInfo } from 'redpoints-front-components';
import { Col, Info, Row } from 'redpoints-front-components/index';

import { getIncidentDetailsIncidentData } from '../../../reducers/reporting/incidentDetails';
import { translate } from '../../../helpers/languageHelper';

const IncidentStatus = ({ incidentStatus, incidentDiscardedReason }) => {
  if (!incidentStatus) return null;

  const isIncidentDiscarded =
    incidentStatus.name === IncidentStatusEnum.INCIDENT_DISCARDED.name;
  const discardedReason = incidentDiscardedReason?.name;
  const shouldRenderMoreInfo = isIncidentDiscarded && discardedReason;

  return (
    <>
      <span>{translate(incidentStatus.literalKey)}</span>
      {shouldRenderMoreInfo && <MoreInfo content={discardedReason} />}
    </>
  );
};

const IncidentDetailsHeader = ({
  incidentData: {
    asset,
    detectionLink,
    incidentDiscardedReason,
    incidentId,
    incidentStatus,
  },
}) => {
  const protectionTypeKey =
    detectionLink?.infringementProtectionType?.literalKey;

  return (
    <div className="incident-details-header-container">
      <Row type="flex">
        <Col lg={6}>
          <Info
            label={translate('reporting.incidentDetails.header.incidentId')}
            value={incidentId}
          />
        </Col>
        <Col lg={6}>
          <Info
            label={translate('reporting.incidentDetails.header.incidentStatus')}
            value={
              <IncidentStatus
                incidentStatus={incidentStatus}
                incidentDiscardedReason={incidentDiscardedReason}
              />
            }
          />
        </Col>
        <Col lg={6}>
          <Info
            label={translate('reporting.incidentDetails.header.assetName')}
            value={asset?.name}
          />
        </Col>
        <Col lg={6}>
          <Info
            label={translate('reporting.incidentDetails.header.protectionType')}
            value={
              protectionTypeKey && translate(`global.${protectionTypeKey}`)
            }
          />
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = state => ({
  incidentData: getIncidentDetailsIncidentData(state),
});

export default connect(mapStateToProps)(IncidentDetailsHeader);
